import React from "react";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BusinessHubNavigation from "../components/BusinessHubNavigation.js";
import ProductSubmission from "../components/ProductSubmission.js";
import "../styles/ProductSubmission.css";

function ProductSubmissionPage() {
  return (
    <div className="productSubmission-screen">
      <div className="productSubmission-header-container">
        <BusinessHubHeader />
      </div>
      <div className="productSubmission-page-content-container">
        <div className="business-hub-navigation-sidebar">
          <BusinessHubNavigation mode="prod" active="D" />
        </div>
        <div className="productSubmission-content-container">
          <div className="productSubmission-content-card">
            <ProductSubmission />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductSubmissionPage;
